import { render, staticRenderFns } from "./wdSet.vue?vue&type=template&id=6a84f0b5&scoped=true&"
import script from "./wdSet.vue?vue&type=script&lang=js&"
export * from "./wdSet.vue?vue&type=script&lang=js&"
import style0 from "./wdSet.vue?vue&type=style&index=0&id=6a84f0b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a84f0b5",
  null
  
)

export default component.exports